import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Keyboard, ViewController, Slides } from 'ionic-angular';
import { HttpServiceProvider } from '../../providers/http-service/http-service';
import { AlertProvider } from '../../providers/alert/alert';
import { ToastProvider } from '../../providers/toast/toast';
import { RequestOptions, Http, Headers } from '@angular/http';
import 'rxjs/add/operator/timeout';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GruposPage } from '../grupos/grupos';
import { Geolocation } from '@ionic-native/geolocation';

@IonicPage()
@Component({
  selector: 'page-listarcomanda',
  templateUrl: 'listarcomanda.html',
})
export class ListarcomandaPage {
  @ViewChild('slides') slides: Slides;

  totalProdutos: any;
  total: number = 0.00;
  adicionalServico: any;
  taxaEntrega: number = 0.00;
  Cart: any[] = [];
  produtos: any[] = [];
  bairros: any[] = [];
  agruparProdutosToggle: boolean = false;
  quantidade = 1;
  formaPagamento: ""
  troco: boolean = true;
  valorTroco: string = "";
  pet: any = "entrega"
  cidadeEntrega: any = ""
  dadosEmpresa = {
    Emp_Bairro: "",
    Emp_CNPJ: "",
    Emp_Cep: "",
    Emp_Cidade: "",
    Emp_CodMunicipio: "",
    Emp_Complemento: "",
    Emp_Cor: "",
    Emp_Email: "",
    Emp_Endereco: "",
    Emp_IE: "",
    Emp_Logo: "",
    Emp_NomeFantasia: "",
    Emp_NumEndereco: "",
    Emp_Numero: "",
    Emp_RamoAtividade: "",
    Emp_RazaoSocial: "",
    Emp_Telefone: "",
    Emp_UF: "",
    Emp_WhatsApp: "",
    Emp_TempoEntrega: "",
    Emp_TempoRetirada: ""
  }

  dadosPedido = {
    nomeCliente: "",
    celularCliente: "",
    dadosPagamento: {
      formaPgto: "",
      valorTroco: 0.00,
      bandeiraCartao: ""
    },
    dadosEntrega: {
      formaTransporte: "entrega",
      Bai_Codigo: 0,
      logradouro: "",
      complemento: "",
      bairro: "",
      numCasa: "",
      pontoRef: "",
      cidade: "",
      uf: ""
    },
    subTotal: 0,
    taxaEntrega: 0,
    total: 0,
    produtos: []
  }

  formularioPedido: FormGroup
  errorNomeCliente: boolean = false
  mensagemErrorNomeCliente: string = ""
  errorCelularCliente: boolean = false
  mensagemErrorCelularCliente: string = ""
  errorLogradouro: boolean = false
  mensagemErrorLogradouro: string = ""
  errorNumCasa: boolean = false
  mensagemErrorNumCasa: string = ""
  errorCidade: boolean = false
  mensagemErrorCidade: string = ""
  errorFormaPgto: boolean = false
  mensagemErrorFormaPgto: string = ""

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public httpService: HttpServiceProvider,
    public toastCtrl: ToastProvider,
    public alertCtrl: AlertProvider,
    public loadingCtrl: LoadingController,
    public http: Http,
    public keyboard: Keyboard,
    public viewCtrl: ViewController,
    public geolocationCtrl: Geolocation,
    public formBuilder: FormBuilder
  ) {
    this.formularioPedido = new FormGroup({
      nomeCliente: new FormControl('', [Validators.required]),
      celularCliente: new FormControl('', Validators.compose([Validators.required, Validators.minLength(10), PhoneValidator.validPhone])),
      logradouro: new FormControl('', [Validators.required]),
      numCasa: new FormControl('', [Validators.required]),
      formaPgto: new FormControl('', [Validators.required]),
    });
    this.dadosEmpresa = Object.assign({}, JSON.parse(localStorage.getItem("dadosEmpresa")))

    this.httpService.get("listarBairros").toPromise().then((result: any) => {
      this.bairros = result
    })
  }
  nextSlide() {
    this.slides.lockSwipes(false)
    this.slides.slideNext()
    this.slides.lockSwipes(true)
  }
  keyboardIsOpen() {
    return this.keyboard.isOpen()
  }

  prevSlide() {
    this.slides.lockSwipes(false)
    this.slides.slidePrev()
    this.slides.lockSwipes(true)
  }

  entregaRetiradaFuncao(valor) {
    this.dadosPedido.dadosEntrega.formaTransporte = valor
    if (valor == 'retirarLocal') {
      this.taxaEntrega = 0
      this.cidadeEntrega = ''
      this.dadosPedido.taxaEntrega = 0
      this.dadosPedido.dadosEntrega.cidade = ''
      this.dadosPedido.dadosEntrega.uf = ''
      this.dadosPedido.dadosEntrega.bairro = ''
      this.dadosPedido.dadosEntrega.numCasa = ''
      this.dadosPedido.dadosEntrega.complemento = ''
      this.dadosPedido.dadosEntrega.logradouro = ''
      this.dadosPedido.dadosEntrega.Bai_Codigo = 0
      this.dadosPedido.dadosEntrega.pontoRef = '';
      this.atualizarTotal()
    }
  }

  fecharModalPedido() {
    this.viewCtrl.dismiss()
  }

  abrirLocalizacao() {
    location.href = "https://www.google.com/maps/dir/" + this.dadosEmpresa.Emp_Endereco + ", " + this.dadosEmpresa.Emp_NumEndereco + " - " + this.dadosEmpresa.Emp_Cidade
  }

  habilitaBotaoEnviar() {
    if (this.dadosPedido.dadosEntrega.formaTransporte == 'entrega') {
      if (!this.formularioPedido.controls.nomeCliente.valid || !this.formularioPedido.controls.celularCliente.valid || this.dadosPedido.dadosEntrega.Bai_Codigo != 0) {
        if (this.dadosPedido.dadosPagamento.formaPgto == 'Maquininha') {
          if (this.dadosPedido.dadosPagamento.bandeiraCartao != '') {
            return false
          }
        } else {
          return false
        }
      }
    } else {
      if (this.formularioPedido.controls.nomeCliente.valid || this.formularioPedido.controls.celularCliente.valid) {
        return false
      }
    }
  }

  atualizaTaxaEntrega(Bai_Codigo) {
    let bairro = this.bairros.find(item => item.Bai_Codigo == Bai_Codigo)
    this.dadosPedido.total = this.dadosPedido.subTotal + bairro.Bai_TaxaEntrega
    this.total = this.totalProdutos + bairro.Bai_TaxaEntrega
    this.taxaEntrega = bairro.Bai_TaxaEntrega
    this.cidadeEntrega = bairro.Bai_NomeMunicipio + "/" + bairro.Bai_UFMunicipio
    this.dadosPedido.taxaEntrega = bairro.Bai_TaxaEntrega
    this.dadosPedido.dadosEntrega.cidade = bairro.Bai_NomeMunicipio
    this.dadosPedido.dadosEntrega.uf = bairro.Bai_UFMunicipio
    this.dadosPedido.dadosEntrega.bairro = bairro.Bai_Nome
  }

  ionViewDidEnter() {
    this.Cart = JSON.parse(localStorage.getItem("NovosProdutos"))
    this.atualizarTotal()
    document.querySelector('ion-segment-button[title=A]').classList.add('segment-activated')
    this.slides.lockSwipes(true)
  }

  updateCart() {
    if (this.agruparProdutosToggle) {
      this.Cart = JSON.parse(localStorage.getItem("CartAgrupado"));
    } else {
      this.Cart = JSON.parse(localStorage.getItem("Cart"));
    }
    if (this.Cart == null) {
      this.Cart = [];
    }

    this.atualizarTotal();
    localStorage.setItem("agruparProdutos", this.agruparProdutosToggle === true ? "true" : "false")
  }

  add(i) {
    let vlrTotalComplemento = 0
    this.Cart[i].quantidade++
    this.Cart[i].complementos.forEach(item => {
      vlrTotalComplemento = vlrTotalComplemento + item.Com_Preco
    })
    this.Cart[i].vlrTotalItem = (this.Cart[i].vlrUnitario + vlrTotalComplemento) * this.Cart[i].quantidade
    this.Cart[i].vlrTotalComplementos = vlrTotalComplemento * this.Cart[i].quantidade
    this.atualizarTotal()
  }

  remove(i) {
    if (this.Cart[i].quantidade > 1) {
      let vlrTotalComplemento = 0
      this.Cart[i].quantidade = this.Cart[i].quantidade - 1
      this.Cart[i].complementos.forEach(item => {
        vlrTotalComplemento = vlrTotalComplemento + item.Com_Preco
      })
      this.Cart[i].vlrTotalItem = (this.Cart[i].vlrUnitario + vlrTotalComplemento) * this.Cart[i].quantidade
      this.Cart[i].vlrTotalComplementos = vlrTotalComplemento * this.Cart[i].quantidade
      this.atualizarTotal()
    }
  }

  deleteItem(i) {
    this.Cart.splice(i, 1)
    this.atualizarTotal()
    if (this.Cart.length == 0) {
      this.Cart = undefined
      this.fecharModalPedido()
    }
  }

  formataMoeda(valor) {
    return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
  }

  atualizarTotal() {
    if (this.Cart) {
      localStorage.setItem("NovosProdutos", JSON.stringify(this.Cart))
      let subTotal = 0;
      for (var i = 0; i <= this.Cart.length - 1; i++) {
        subTotal = subTotal + this.Cart[i].vlrTotalItem;
      } 
      this.totalProdutos = subTotal;
      this.total = subTotal
      this.dadosPedido.subTotal = subTotal
      this.dadosPedido.total = subTotal
    }
  }

  validaCampos() {
    let { nomeCliente, celularCliente, numCasa, logradouro } = this.formularioPedido.controls
    if (!this.formularioPedido.valid && nomeCliente.dirty) {
      if (!nomeCliente.valid) {
        this.errorNomeCliente = true
        this.mensagemErrorNomeCliente = "Campo Nome Obrigatório!"
      } else {
        this.errorNomeCliente = false
      }
    } else {
      this.errorNomeCliente = false
    }

    //validação do celular
    //console.log(celularCliente);
    if (!this.formularioPedido.valid && celularCliente.dirty) {
      if (!celularCliente.valid) {
        this.errorCelularCliente = true;
        this.mensagemErrorCelularCliente = "Número inválido.";
      } else {
        this.errorCelularCliente = false;
      }
    } else {
      this.errorCelularCliente = false;
    }

    if (!this.formularioPedido.valid && logradouro.dirty) {
      if (!logradouro.valid) {
        this.errorLogradouro = true
        this.mensagemErrorLogradouro = "Campo Endereço Obrigatório!"
      } else {
        this.errorLogradouro = false
      }
    } else {
      this.errorLogradouro = false;
    }


    if (!this.formularioPedido.valid && numCasa.dirty) {
      if (!numCasa.valid) {
        this.errorNumCasa = true
        this.mensagemErrorNumCasa = "Campo Número Obrigatório!"
      } else {
        this.errorNumCasa = false
      }
    } else {
      this.errorNumCasa = false;
    }

  }

  validaTroco() {
    return !this.troco ? parseFloat(this.valorTroco) <= this.dadosPedido.total ? true : false : false
  }

  removeCaracteres(valor) {
    valor = valor.replace()
  }

  salvarPedido() {
    this.dadosPedido.produtos = JSON.parse(localStorage.getItem("NovosProdutos"))
    this.dadosPedido.celularCliente = this.dadosPedido.celularCliente.replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, "")
    this.valorTroco != "" ? this.dadosPedido.dadosPagamento.valorTroco = parseFloat(this.valorTroco) : 0.00
    let loader = this.loadingCtrl.create({
      content: "Enviando pedido, aguarde..."
    });
    loader.present();
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');

    let options = new RequestOptions({ headers: headers });
    console.log(this.dadosPedido)
    this.httpService.post(JSON.stringify(this.dadosPedido), options).timeout(8000).toPromise().then(res => {
      loader.dismiss();
      if (this.dadosPedido.dadosEntrega.formaTransporte == "entrega") {
        this.alertCtrl.alertValidaCampos("Pedido enviado com sucesso", "Tempo para entrega de " + this.dadosEmpresa.Emp_TempoEntrega + " minutos.")
      } else {
        this.alertCtrl.alertValidaCampos("Pedido enviado com sucesso", "Tempo para retirada de " + this.dadosEmpresa.Emp_TempoRetirada + " minutos.")
      }
      this.navCtrl.setRoot(GruposPage);
    }).catch(err => {
      console.log('Erro ao salvar pedido.' + err);
      this.alertCtrl.alertValidaCampos('Falha na comunicação com o servidor. Verifique a rede.', '');
      loader.dismiss();
    })
  }
}

export class PhoneValidator {
  static validPhone(fc: FormControl) {

    //verifica se possui pelo menos 3 digitos diferentes no numero
    let countNumbersDiff = 0;
    let numeros = "";

    for (let x = 0; x < fc.value.length; x++) {
      if (!numeros.includes(fc.value[x])) {
        numeros = numeros + fc.value[x];
        countNumbersDiff++;
      }
    }

    if (countNumbersDiff < 3) {
      return { validPhone: false };
    } else {
      return null;
    }
  }
}  


// WEBPACK FOOTER //
// ./src/pages/listarcomanda/listarcomanda.ts